import { createFileRoute } from "@tanstack/react-router";
import FAQPage from "@/pages/FAQ";
import { pageHead } from "@/lib/pageHead";
import { faqJsonLd } from "@/lib/faqContent";

export const Route = createFileRoute("/faq")({
  head: () => ({
    ...pageHead("faq", "es"),
    scripts: [{ type: "application/ld+json", children: JSON.stringify(faqJsonLd("es")) }],
  }),
  component: FAQPage,
});
